<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex ">
            <section class="mu-d-flex mu-flex-row">
                <h1 class="mu-mb-00">Jobs</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content mu-pl-05">
                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb ">
                <li>Process engine</li>
                <li>Jobs</li>
                <li class="lastBredCrumpLi">
                </li>
            </ol>
        </nav>
        <div>
            <div >
                <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="filterTable" title="Job Filters">
                  
                        <div class="mcc-card mu-border-0">
                            <div class="mcc-row" v-if="!fetchCall">
                                <div class="mcc-col colSpinner">
                                    <div class="spinner-overlay">
                                        <div class="spinner-background"></div>
                                        <div class="spinner-flex">
                                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mcc-row" v-show="fetchCall">
                                <form id="formIdd">
                                <div>
                                    <div class="mfc-slim-select-wrapper mfc-form-input-container mu-mb-05">
                                        <label for="jobType">Job type</label>
                                        <select id="jobType" @change="jobTypeRef = $event.target.value" name="jobType" block>
                                            <option data-placeholder="true" value=""></option>
                                            <option value="Executable" :selected="jobTypeRef =='Executable'">Executable</option>
                                            <option value="Timer" :selected="jobTypeRef =='Timer'">Timer</option>
                                            <option value="Suspended" :selected="jobTypeRef =='Suspended'">Suspended</option>
                                            <option value="Failed" :selected="jobTypeRef =='Failed'">Failed</option>
                                        </select>
                                    </div>
                                    <div class="mfc-slim-select-wrapper mfc-form-input-container mu-mb-05">
                                        <label for="processDefinationId">Process definition</label>
                                        <select id="processDefinationId" @change="procDefIdRef = $event.target.value" name="processDefinition" block>
                                            <option data-placeholder="true" value="" :selected="procDefIdRef ==''"></option>
                                            <option v-for="(process,key) in procDefs" :selected="procDefIdRef == process.id" :key="key" :value="process.id">{{process.id}}</option>
                                        </select>
                                    </div>
                                    <div class="mfc-input-wrapper mfc-form-input-container mu-mb-05">
                                        <label for="processInstanceId">Process instance ID</label>
                                        <input type="text" name="processInstanceId" id="processInstanceId" :value="procInstIdRef" @change="procInstIdRef = $event.target.value">
                                    </div>
                                    <div class="flatpickr flatpickrGap mfc-input-wrapper mfc-form-input-container flatpickrInstance mu-mb-05">
                                        <label for="dueBeforeId" class=" mu-mb-00">Due before</label>
                                        <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text  ">
                                            <input name="dueBefore" placeholder="Select Date.." data-input id="dueBeforeId"  ref="dueBefore" block prepend icon="calendar" @change="dueBeforeRef = $event.target.value" @ready="handleDueBeforeReady()" :value="dueBeforeRef">
                                            <button type="button" class="mcc-button mcc-button--outline" data-toggle aria-label="date">
                                                <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                            </button>
                                            <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                                <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                                <span>Please select proper dates.</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flatpickr flatpickrGap mfc-input-wrapper mfc-form-container flatpickrInstances mu-mb-05">
                                        <label for="dueAfterId" class=" mu-mb-00">Due after</label>
                                        <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text">
                                            <input data-input name="dueAfter" placeholder="Select Date.." id="dueAfterId"  ref="dueAfter" block prepend icon="calendar" @change="dueAfterRef = $event.target.value" @ready="handleDueAfterReady()" :value="dueAfterRef">
                                            <button type="button" class="mcc-button mcc-button--outline" data-toggle aria-label="date">
                                                <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                            </button>
                                            <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                                <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                                <span>Please select proper dates.</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                        <input type="checkbox" id="onlyJobsWithExc" name="onlyJobsWithExc" :checked="onlyJobsWithExcRef" @change="onlyJobsWithExcRef = $event.target.checked" color="primary" class="mfc-switch">
                                        <label for="mds-mwXh3qtx">Only jobs with exception</label>
                                    </div>
                                </div>
                            </form>
                            </div>
                        </div>
                  
                </Drawer>
                <div class="mcc-row">
                    <div class="mcc-col">
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-card">
                                <div class="mcc-card__body">
                                    <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                        <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                            <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                            <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : ''}}</span>
                                        </button>
                                    </div>
                                    <mcc-data-table ref="jobTable" id="jobTableId"></mcc-data-table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
           </div>
        </div>
    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import JobAPI from "../../../services/JobAPI";
import Utils from "@/script_utils";
import Drawer from "../../common/Drawer.vue";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "JobList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["processengine.job.list"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            jobs: {},
            procDefs: [],
            updateDialog: false,
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            jobTypeRef: "Executable",
            jobType: "Executable",
            procDefIdRef: "",
            procDefId: "",
            procInstIdRef: "",
            procInstId: "",
            dueBeforeRef: [],
            dueBefore: "",
            dueAfterRef: [],
            tableData: [],
            dueAfter: "",
            onlyJobsWithExcRef: false,
            onlyJobsWithExc: false,
            fetchCall: false,
            filterCount: 0,
            filterActive: false,
            filterData: [],
            selectInstanceJobType: null,
            selectInstanceProcess: null,
        };
    },

    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        if (localStorage.getItem("jobList") == "jobList") {
            this.jobType = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_jobType"
            );
            this.jobTypeRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_jobType"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_jobType"
            );

            this.procDefId = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_procDefId"
            );
            this.procDefIdRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_procDefId"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_procDefId"
            );

            this.procInstId = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_procInstId"
            );
            this.procInstIdRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_procInstId"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_procInstId"
            );

            let onlyJobsWithExcString = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_onlyJobsWithExc"
            );
            if (onlyJobsWithExcString == "true") {
                this.onlyJobsWithExc = true;
                this.onlyJobsWithExcRef = true;
            } else {
                this.onlyJobsWithExc = false;
                this.onlyJobsWithExcRef = false;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_onlyJobsWithExc"
            );
            let dueBeforeString = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_dueBeforeRef"
            );
            if (dueBeforeString != "") {
                this.dueBeforeRef[0] = dueBeforeString;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_dueBeforeRef"
            );

            let dueAfterString = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_dueAfterRef"
            );
            if (dueAfterString != "") {
                this.dueAfterRef[0] = dueAfterString;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_dueAfterRef"
            );
            this.updateDateRef();

            this.currentPageSize = parseInt(
                localStorage.getItem("jobListPageSize")
            );

            localStorage.removeItem("jobList");
            localStorage.removeItem("jobListPageSize");
            this.filterCount = parseInt(
                localStorage.getItem("auditListFilterCount")
            );
            localStorage.removeItem("auditListFilterCount");

        }

        JobAPI.getProcessDefinitionList()
            .then(result => {
                self.procDefs = result;
                self.fetchCall = true;
            })
            .finally(() => {
                this.getJobsData();
                this.selectInstanceJobType = new SlimSelect({
                    select: '#jobType',

                })
                this.selectInstanceProcess = new SlimSelect({
                    select: '#processDefinationId',

                })
                this.flatPickr();
            });

    },
    methods: {
        getFilterCount() {
            if (this.jobTypeRef != "")
                this.filterCount += 1
            if (this.procDefIdRef != "")
                this.filterCount += 1
            if (this.dueAfter != "")
                this.filterCount += 1
            if (this.dueBefore != "")
                this.filterCount += 1
        },
        filterFunctionList(filteredRows, filterValue) {

            this.name = filterValue;
            this.initJobTable();
            this.name = "";
            return filteredRows.filter(function (r) {
                return (

                    r.exceptionMessage.toString().toLowerCase().includes(filterValue.toLowerCase()) ||
                    r.id.toLowerCase().includes(filterValue.toLowerCase()) ||
                    r.processDefinitionId.toLowerCase().includes(filterValue.toLowerCase())
                );
            })
        },
        updateOrderList(filteredOrderList) {
            this.filterData = filteredOrderList;
            this.filterActive = true;
            this.initJobTable();
        },
        resetSlimSelect() {
            this.selectInstanceJobType.setSelected('')
            this.selectInstanceProcess.setSelected('')
        },
        flatPickr() {
            let self = this;

            self.flatPickerInstance = flatpickr('.flatpickrInstance', {
                dateFormat: 'm/d/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                mode: 'single',
                wrap:true,
                defaultDate: [self.dueBeforeRef[0], self.dueBeforeRef[1]],
            })
            self.flatPickerInstances = flatpickr('.flatpickrInstances', {
                dateFormat: 'm/d/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                mode: 'single',
                wrap:true,
                defaultDate: [self.dueAfterRef[0], self.dueAfterRef[1]],
            })

        },
        filterTable() {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.updateDateRef()
            this.filterCount = 0;
            this.jobType = this.jobTypeRef;
            this.procDefId = this.procDefIdRef;
            this.procInstId = this.procInstIdRef;
            this.onlyJobsWithExc = this.onlyJobsWithExcRef;
            this.getFilterCount();
            this.initJobTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        updateDateRef() {
            this.dueAfter = "";
            this.dueBefore = "";
            if (this.dueBeforeRef.length > 0) {

                this.dueBefore = this.formattedDate(new Date(this.dueBeforeRef));
            }
            if (this.dueAfterRef.length > 0) {
                this.dueAfter = this.formattedDate(new Date(this.dueAfterRef));
            }
        },
        formattedDate(d) {
            let month = String(d.getMonth() + 1);
            let day = String(d.getDate());
            const year = String(d.getFullYear());

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return day + "/" + month + "/" + year;
        },
        handleDueBeforeReady() {
            this.$refs.dueBefore.value = this.dueBeforeRef;
        },
        handleDueAfterReady() {
            this.$refs.dueAfter.value = this.dueAfterRef;
        },
        getJobsData() {
            let self = this;
            this.$nextTick(() => {
                self.initJobTable();
            });
        },
        resetFilter() {
            this.updateCall = false;
            this.filterCount = 0;
            this.jobType = "Executable";
            this.jobTypeRef = "Executable";
            this.procInstId = "";
            this.procInstIdRef = "";
            this.dueBefore = "";
            this.dueBeforeRef = [];
            this.dueAfter = "";
            this.dueAfterRef = [];
            this.onlyJobsWithExc = false;
            this.onlyJobsWithExcRef = false;
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.initJobTable();
            this.resetSlimSelect();
            flatpickr("#dueBeforeId").destroy();
            this.flatPickr();
            this.changeDateRangeRef = [];
        },
        updateTemplate() {
            let self = this;
            this.$refs.jobTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(self.CONTEXT_PATH + "/processengine/jobs/" + reference.trim() + "?jobType=" + self.jobType);
                        }
                    });
                });
            this.$refs.jobTable
                .querySelectorAll('td [class="table-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(self.CONTEXT_PATH + "/processengine/processdefinitions/" + reference.trim());
                        }
                    });
                });
            $(".dueDateDiv").each((a, obj) => {
                let dueDate = $(obj).attr("name");
                let htmlTag = "";
                if (dueDate != "") {
                    let dueDateFormattted = new Date(dueDate).toLocaleString("en-GB")
                        .replace(/\,/g, '');
                    htmlTag +=
                        '<div class="dueDateDiv" name="' +
                        dueDate + '">' +
                        dueDateFormattted +
                        '</span>';
                }
                $(obj).html(htmlTag);
                $(obj).removeClass("d-none");
            });
        },
        initJobTable() {
            let self = this;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const table = document.getElementById("jobTableId");
            self.tableObj = window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No jobs found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        id: {
                            type: "string",
                            title: "ID",
                            template: '<a class="name-link" data-id="{{id}}">{{id}}</a>',
                            sortable: true,
                            columnSearch: false
                        },
                        dueDate: {
                            type: "string",
                            title: "Due",
                            sortable: true,
                            template: '<div class="dueDateDiv d-none" name="{{dueDate}}">{{dueDate}}<div>',
                            columnSearch: false
                        },
                        processDefinitionId: {
                            type: "string",
                            title: "Process definition",
                            template: '<a class="table-link" data-id="{{processDefinitionId}}">{{processDefinitionId}}</a>',
                            sortable: false,
                            columnSearch: false
                        },
                        retries: {
                            type: "string",
                            title: "Retries",
                            sortable: false,
                            columnSearch: false
                        },
                        exceptionMessage: {
                            type: "string",
                            title: "Exception",
                            sortable: false,
                            columnSearch: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "id"
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc"
                        }

                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection;
                        queryString += "&jobType=" + self.jobType;
                        if (self.procDefId != "") {
                            queryString += "&processDefinationId=" + self.procDefId;
                        }
                        if (self.procInstId != "") {
                            queryString += "&processInstanceId=" + self.procInstId;
                        }
                        if (self.dueBefore != "") {
                            queryString += "&dueBefore=" + self.dueBefore;
                        }
                        if (self.dueAfter != "") {
                            queryString += "&dueAfter=" + self.dueAfter;
                        }
                        if (self.onlyJobsWithExc) {
                            queryString += "&withException=" + self.onlyJobsWithExc;
                        }
                        return JobAPI.getJobsList(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                            }
                            self.updateCall = true;
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onPageChange: (table, start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("jobListPageSize", this.tableObj.tableContext.store.state.pageSize);
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_jobType",
                this.jobType
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_procDefId",
                this.procDefId
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_procInstId",
                this.procInstId
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_onlyJobsWithExc",
                this.onlyJobsWithExc
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_dueBeforeRef",
                this.dueBeforeRef
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_dueAfterRef",
                this.dueAfterRef
            );
            localStorage.setItem("auditListFilterCount", this.filterCount);
        }
    }
};
</script>

<style scoped>
.flatpickrGap {
    gap: 0.25rem;
}
</style>
